/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainStoreEnumsOrderStateFromJSON, FxIdDomainStoreEnumsOrderStateToJSON, } from './FxIdDomainStoreEnumsOrderState';
import { FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataFromJSON, FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataToJSON, } from './FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsData';
import { FxIdApplicationStorePriceDataFromJSON, FxIdApplicationStorePriceDataToJSON, } from './FxIdApplicationStorePriceData';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPaymentStatusResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPaymentStatusResponse(value) {
    if (!('Status' in value) || value['Status'] === undefined)
        return false;
    if (!('OrderProducts' in value) || value['OrderProducts'] === undefined)
        return false;
    if (!('TotalPrice' in value) || value['TotalPrice'] === undefined)
        return false;
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseFromJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Status': FxIdDomainStoreEnumsOrderStateFromJSON(json['Status']),
        'OrderProducts': FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataFromJSON(json['OrderProducts']),
        'TotalPrice': FxIdApplicationStorePriceDataFromJSON(json['TotalPrice']),
        'Game': json['Game'],
    };
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseToJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Status': FxIdDomainStoreEnumsOrderStateToJSON(value['Status']),
        'OrderProducts': FxIdWebFeaturesStoreGetPaymentStatusResponseOrderProductsDataToJSON(value['OrderProducts']),
        'TotalPrice': FxIdApplicationStorePriceDataToJSON(value['TotalPrice']),
        'Game': value['Game'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreGetPaymentStatusResponse.js.map